import calcularFechas from '@/helpers/FechaDesdeMenorQueFechaHasta'

/**
 * Dado horariosRegulares (mismo formato que api: array de grupos por día, cada grupo es array de { Id, Dia, HsDesde, HsHasta }),
 * calcula si está "cerrado" en la fecha dada.
 * Si horariosRegulares es null/undefined o vacío, retorna null (indica que se debe usar el horario general de la tienda).
 * @param {Array} horariosRegulares - Array de grupos (cada grupo es array de { Id, Dia, HsDesde, HsHasta })
 * @param {Date} [fecha=new Date()] - Fecha a evaluar
 * @returns {boolean|null} true = cerrado, false = abierto, null = usar horario general
 */
export function computarNegocioCerrado (horariosRegulares, fecha = new Date()) {
  if (!horariosRegulares || !Array.isArray(horariosRegulares) || horariosRegulares.length === 0) {
    return null
  }
  const fechaAuxiliar = new Date(fecha)
  const diaHoy = fechaAuxiliar.getDay() === 0 ? 7 : fechaAuxiliar.getDay()
  const diaActual = horariosRegulares.filter(hr => hr.filter(e => e.Id === diaHoy).length > 0)
  const negocioCerrado = diaActual.filter(e => e.filter(s => calcularFechas(fechaAuxiliar, s)).length > 0).length === 0

  // Si según el día "actual" está cerrado, verificamos si seguimos dentro
  // de un rango horario que empezó el día anterior y cruza la medianoche
  if (negocioCerrado) {
    const fechaAyer = new Date(fecha)
    fechaAyer.setDate(fechaAyer.getDate() - 1)
    const diaAyer = fechaAyer.getDay() === 0 ? 7 : fechaAyer.getDay()

    // Tomamos solo los rangos del día anterior que cruzan la medianoche
    const diaAnteriorConCruce = horariosRegulares.filter(
      hr => hr.filter(e => e.Id === diaAyer && e.HsDesde.localeCompare(e.HsHasta) > 0).length > 0
    )

    const sigueAbiertoPorCruce = diaAnteriorConCruce.filter(
      e => e.filter(s => calcularFechas(new Date(fechaAyer), s)).length > 0
    ).length > 0

    if (sigueAbiertoPorCruce) {
      return false
    }
  }

  return negocioCerrado
}

/**
 * Indica si una categoría está disponible ahora según sus horarios.
 * Si la categoría tiene horariosRegulares propios, predominan sobre el horario general.
 * @param {Object} categoria - Categoría con opcional horariosRegulares
 * @param {Object} horarioGeneral - { negocioCerrado } del store app.data.horarioRegular
 * @param {Date} [fecha=new Date()]
 * @returns {boolean} true = disponible para comprar, false = fuera de horario o cerrado
 */
export function isCategoriaDisponible (categoria, horarioGeneral, fecha = new Date()) {
  const cerradoCategoria = computarNegocioCerrado(categoria?.horariosRegulares, fecha)
  // Si la categoría no tiene horarios propios configurados
  if (cerradoCategoria === null) {
    // Si no hay horario general configurado o no hay datos de horarios,
    // se asume que la categoría está siempre disponible.
    if (
      !horarioGeneral ||
      !horarioGeneral.dataOriginal ||
      !Array.isArray(horarioGeneral.dataOriginal) ||
      horarioGeneral.dataOriginal.length === 0 ||
      typeof horarioGeneral.negocioCerrado !== 'boolean'
    ) {
      return true
    }

    // Caso normal: usar el estado de negocioCerrado del horario general
    return !horarioGeneral.negocioCerrado
  }

  // Si la categoría sí tiene horarios propios, usar ese resultado
  return !cerradoCategoria
}

export default { computarNegocioCerrado, isCategoriaDisponible }
